/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ConsentContextOutState = typeof ConsentContextOutState[keyof typeof ConsentContextOutState];


export const ConsentContextOutState = {
  fresh: 'fresh',
  used: 'used',
  expired: 'expired',
} as const;
